export default "__VITE_ASSET__p3dtiJ_R__"